import { render, staticRenderFns } from "./Subsede.vue?vue&type=template&id=d9d080c6&"
import script from "./Subsede.vue?vue&type=script&lang=js&"
export * from "./Subsede.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports